import React from "react";
import Popup from "../../Helpers/Popup/Popup";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import trans from "../../../utils";
import Close from "../../Helpers/CloseBtn/Close";
import InspectionRequestQA from "./InspectionRequestQA";
import InspectionRequestConsultantQA from "./InspectionRequestConsultantQA";

export default function InspectonRequestPopupAction({
	qaAction,
	setQAAction,
	deficienciesLen,
	refetch,
}) {
	const inf = useSelector((state) => state.users.user);
	return (
		<>
			<Popup show={qaAction}>
				<Modal.Header className="modal-header flex-between">
					<Modal.Title id="contained-modal-title-vcenter">
						<PopupTitle
							headtitle={
								inf.attributes.role === "qa"
									? trans("QA Review")
									: trans("Consultant Review")
							}
						/>
					</Modal.Title>
					<Close
						// eslint-disable-next-line react/style-prop-object
						style="close-32 close"
						close={() => setQAAction(false)}
						img="Close"
					/>
				</Modal.Header>
				<Modal.Body className="modal-body-scrollable">
					{inf.attributes.role === "qa" ? (
						<InspectionRequestQA
							setQAAction={setQAAction}
							deficienciesLen={deficienciesLen}
							refetch={refetch}
						/>
					) : (
						<InspectionRequestConsultantQA
							setQAAction={setQAAction}
							refetch={refetch}
						/>
					)}
				</Modal.Body>
			</Popup>
		</>
	);
}
